export const getObituarySearchParams = (params: any) => {
  const name = [params!.first_name, params!.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  const isUnknown = (value: string | null | undefined): boolean =>
    value === null ||
    value === undefined ||
    (typeof value === 'string' &&
      (value.trim() === '' ||
        value.trim().toLowerCase().includes('unknown') ||
        value.trim().toLowerCase().includes('null')));
  const dob =
    !isUnknown(params!.birth_month) && !isUnknown(params!.birth_year)
      ? `${String(params!.birth_year)}-${String(params!.birth_month).padStart(
          2,
          '0'
        )}`
      : undefined;
  const dod =
    !isUnknown(params!.death_month) && !isUnknown(params!.death_year)
      ? `${String(params!.death_year)}-${String(params!.death_month).padStart(
          2,
          '0'
        )}`
      : !isUnknown(params!.death_year)
      ? String(params!.death_year)
      : undefined;
  const location = [params!.city, params!.state]
    .filter((p) => p?.trim())
    .join(', ')
    .trim();

  return {
    name,
    dob,
    dod,
    location,
  };
};
